class ProblemDetailError extends Error {
    name;
    message;
    constructor(problemDetail) {
        super(`${problemDetail.title}: (${problemDetail.detail} - ${problemDetail.type} - ${problemDetail.status} - ${problemDetail.instance}`);
        this.name = 'Internal API Server Error';
    }
}
export default ProblemDetailError;
